import { Record, Union } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { array_type, class_type, record_type, option_type, bool_type, string_type, int32_type, union_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";

export class RuleScope extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Global", "PerTrack", "PerTrackLevel"];
    }
}

export function RuleScope_$reflection() {
    return union_type("Shared.RuleModels.RuleScope", [], RuleScope, () => [[], [], []]);
}

export function RuleScope__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function RuleScope_FromInt_Z524259A4(n) {
    switch (n) {
        case 0:
            return new RuleScope(0, []);
        case 1:
            return new RuleScope(1, []);
        case 2:
            return new RuleScope(2, []);
        default:
            return new RuleScope(0, []);
    }
}

export function RuleScope__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return "Per læringsløp";
        case 2:
            return "Per nivå";
        default:
            return "Globalt (alle brukere)";
    }
}

export class TriggerType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OnTaskCompletion", "OnEventSignupDeadline", "GlobalDaysOfInactivity", "GlobalDaysAfterVerification", "GlobalOnUserApproval", "TrackDaysOfInactivity", "TrackDaysAfterEnrollment", "TrackOnSignup", "LevelDaysOfInactivity", "LevelDaysOnLevel", "LevelOnPromotion", "LevelOnCourseSetCompletion"];
    }
}

export function TriggerType_$reflection() {
    return union_type("Shared.RuleModels.TriggerType", [], TriggerType, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export function TriggerType__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 14;
        case 2:
            return 20;
        case 3:
            return 21;
        case 4:
            return 22;
        case 5:
            return 30;
        case 6:
            return 31;
        case 7:
            return 32;
        case 8:
            return 40;
        case 9:
            return 41;
        case 10:
            return 42;
        case 11:
            return 43;
        default:
            return 10;
    }
}

export function TriggerType_FromInt_Z524259A4(n) {
    switch (n) {
        case 10:
            return new TriggerType(0, []);
        case 14:
            return new TriggerType(1, []);
        case 20:
            return new TriggerType(2, []);
        case 21:
            return new TriggerType(3, []);
        case 22:
            return new TriggerType(4, []);
        case 30:
            return new TriggerType(5, []);
        case 31:
            return new TriggerType(6, []);
        case 32:
            return new TriggerType(7, []);
        case 40:
            return new TriggerType(8, []);
        case 41:
            return new TriggerType(9, []);
        case 42:
            return new TriggerType(10, []);
        case 43:
            return new TriggerType(11, []);
        default:
            throw new Error(`Unknown trigger type: ${n}`);
    }
}

export function TriggerType__IsTimeBased(this$) {
    switch (this$.tag) {
        case 2:
        case 3:
        case 5:
        case 6:
        case 8:
        case 9:
        case 11:
            return true;
        default:
            return false;
    }
}

export function TriggerType__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return "Ved påmeldingsfrist for kurs";
        case 2:
            return "X dager med inaktivitet (bruker)";
        case 3:
            return "X dager etter verifisering";
        case 4:
            return "Ved godkjenning av bruker";
        case 5:
            return "X dager med inaktivitet (læringsløp)";
        case 6:
            return "X dager etter påmelding";
        case 7:
            return "Ved påmelding til læringsløp";
        case 8:
            return "X dager med inaktivitet (nivå)";
        case 9:
            return "X dager på nivå";
        case 10:
            return "Ved forfremmelse til nivå";
        case 11:
            return "Fullført utvalgte kurs innen frist";
        default:
            return "Ved fullføring av oppgave";
    }
}

export function TriggerType__ToHint(this$) {
    switch (this$.tag) {
        case 1:
            return "Utløses når påmeldingsfristen for et kurs utløper";
        case 2:
            return "Utløses når brukeren har vært inaktiv i systemet i et gitt antall dager";
        case 3:
            return "Utløses et gitt antall dager etter at brukeren ble verifisert";
        case 4:
            return "Utløses umiddelbart når en administrator godkjenner brukeren";
        case 5:
            return "Utløses når brukeren har vært inaktiv på dette læringsløpet i et gitt antall dager";
        case 6:
            return "Utløses et gitt antall dager etter at brukeren ble påmeldt dette læringsløpet";
        case 7:
            return "Utløses umiddelbart når brukeren melder seg på dette læringsløpet";
        case 8:
            return "Utløses når brukeren har vært inaktiv på dette nivået i et gitt antall dager";
        case 9:
            return "Utløses når brukeren har vært på dette nivået i et gitt antall dager";
        case 10:
            return "Utløses umiddelbart når brukeren forfremmes til dette nivået";
        case 11:
            return "Utløses når brukeren har fullført de valgte kursene innen et gitt antall dager";
        default:
            return "Utløses umiddelbart når brukeren fullfører en oppgave";
    }
}

export function TriggerType_get_All() {
    return [new TriggerType(0, []), new TriggerType(1, []), new TriggerType(2, []), new TriggerType(3, []), new TriggerType(4, []), new TriggerType(5, []), new TriggerType(6, []), new TriggerType(7, []), new TriggerType(8, []), new TriggerType(9, []), new TriggerType(10, []), new TriggerType(11, [])];
}

export class ActionType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SendNotification", "SendEmail", "ChangeUserState", "SetTrackInactive", "GrantMaterialAccess", "RevokeMaterialAccess"];
    }
}

export function ActionType_$reflection() {
    return union_type("Shared.RuleModels.ActionType", [], ActionType, () => [[], [], [], [], [], []]);
}

export function ActionType__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 7;
        case 5:
            return 6;
        default:
            return 1;
    }
}

export function ActionType_FromInt_Z524259A4(n) {
    switch (n) {
        case 1:
            return new ActionType(0, []);
        case 2:
            return new ActionType(1, []);
        case 3:
            return new ActionType(2, []);
        case 4:
            return new ActionType(3, []);
        case 6:
            return new ActionType(5, []);
        case 7:
            return new ActionType(4, []);
        default:
            throw new Error(`Unknown action type: ${n}`);
    }
}

export function ActionType__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return "Send e-post";
        case 2:
            return "Endre brukerstatus";
        case 3:
            return "Sett læringsløp inaktivt";
        case 4:
            return "Gi tilgang til materiale";
        case 5:
            return "Fjern tilgang til materiale";
        default:
            return "Send varsel";
    }
}

export function ActionType__ToHint(this$) {
    switch (this$.tag) {
        case 1:
            return "Sender en e-post til valgte mottakere";
        case 2:
            return "Endrer brukerens status (aktiv, deaktivert, etc.)";
        case 3:
            return "Setter brukerens læringsløp til inaktivt";
        case 4:
            return "Gir brukeren tilgang til materialer";
        case 5:
            return "Fjerner brukerens tilgang til materialer";
        default:
            return "Sender et varsel til valgte mottakere i systemet";
    }
}

export function ActionType_get_All() {
    return [new ActionType(0, []), new ActionType(1, []), new ActionType(2, []), new ActionType(3, []), new ActionType(4, []), new ActionType(5, [])];
}

export class RecipientType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AffectedUser", "AllAdmins", "Both"];
    }
}

export function RecipientType_$reflection() {
    return union_type("Shared.RuleModels.RecipientType", [], RecipientType, () => [[], [], []]);
}

export function RecipientType__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function RecipientType_FromInt_Z524259A4(n) {
    switch (n) {
        case 0:
            return new RecipientType(0, []);
        case 1:
            return new RecipientType(1, []);
        case 2:
            return new RecipientType(2, []);
        default:
            throw new Error(`Unknown recipient type: ${n}`);
    }
}

export function RecipientType__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return "Alle administratorer";
        case 2:
            return "Bruker og administratorer";
        default:
            return "Berørt bruker";
    }
}

export class RuleExecutionStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Success", "Failed", "Skipped"];
    }
}

export function RuleExecutionStatus_$reflection() {
    return union_type("Shared.RuleModels.RuleExecutionStatus", [], RuleExecutionStatus, () => [[], [], []]);
}

export function RuleExecutionStatus__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function RuleExecutionStatus_FromInt_Z524259A4(n) {
    switch (n) {
        case 0:
            return new RuleExecutionStatus(0, []);
        case 1:
            return new RuleExecutionStatus(1, []);
        case 2:
            return new RuleExecutionStatus(2, []);
        default:
            throw new Error(`Unknown execution status: ${n}`);
    }
}

export class TriggerConfig extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DaysThreshold", "DaysAfter", "WindowDays", "Immediate"];
    }
}

export function TriggerConfig_$reflection() {
    return union_type("Shared.RuleModels.TriggerConfig", [], TriggerConfig, () => [[["days", int32_type]], [["days", int32_type]], [["days", int32_type]], []]);
}

export function TriggerConfig__GetDays(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0] | 0;
        case 2:
            return this$.fields[0] | 0;
        case 3:
            return 0;
        default:
            return this$.fields[0] | 0;
    }
}

/**
 * Discriminator for the persisted `trigger_config_kind` column.
 */
export function TriggerConfig__KindToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        default:
            return 0;
    }
}

/**
 * Value for the persisted `trigger_config_days` column. `None` for `Immediate`.
 */
export function TriggerConfig__DaysValue(this$) {
    let matchResult, d;
    switch (this$.tag) {
        case 1: {
            matchResult = 0;
            d = this$.fields[0];
            break;
        }
        case 2: {
            matchResult = 0;
            d = this$.fields[0];
            break;
        }
        case 3: {
            matchResult = 1;
            break;
        }
        default: {
            matchResult = 0;
            d = this$.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return d;
        default:
            return undefined;
    }
}

/**
 * Reconstruct from `(kind, days)` columns. Throws on invalid combinations so a corrupt
 * row surfaces immediately instead of silently substituting a default.
 */
export function TriggerConfig_FromColumns_14611EE3(kind, days) {
    let matchResult, k;
    switch (kind) {
        case 0: {
            if (days != null) {
                matchResult = 0;
            }
            else {
                matchResult = 4;
                k = kind;
            }
            break;
        }
        case 1: {
            if (days != null) {
                matchResult = 1;
            }
            else {
                matchResult = 4;
                k = kind;
            }
            break;
        }
        case 2: {
            if (days != null) {
                matchResult = 2;
            }
            else {
                matchResult = 4;
                k = kind;
            }
            break;
        }
        case 3: {
            matchResult = 3;
            break;
        }
        default: {
            matchResult = 4;
            k = kind;
        }
    }
    switch (matchResult) {
        case 0:
            return new TriggerConfig(0, [days]);
        case 1:
            return new TriggerConfig(1, [days]);
        case 2:
            return new TriggerConfig(2, [days]);
        case 3:
            return new TriggerConfig(3, []);
        default:
            throw new Error(`Invalid trigger_config columns: kind=${k}, days=${days}. Each non-Immediate kind requires a days value.`);
    }
}

export class NotificationConfig extends Record {
    constructor(Title, Message, Recipients, SendEmail, Url) {
        super();
        this.Title = Title;
        this.Message = Message;
        this.Recipients = Recipients;
        this.SendEmail = SendEmail;
        this.Url = Url;
    }
}

export function NotificationConfig_$reflection() {
    return record_type("Shared.RuleModels.NotificationConfig", [], NotificationConfig, () => [["Title", string_type], ["Message", string_type], ["Recipients", RecipientType_$reflection()], ["SendEmail", bool_type], ["Url", option_type(string_type)]]);
}

export class ChangeUserStateConfig extends Record {
    constructor(NewState, Notification) {
        super();
        this.NewState = (NewState | 0);
        this.Notification = Notification;
    }
}

export function ChangeUserStateConfig_$reflection() {
    return record_type("Shared.RuleModels.ChangeUserStateConfig", [], ChangeUserStateConfig, () => [["NewState", int32_type], ["Notification", option_type(NotificationConfig_$reflection())]]);
}

export class ActionConfig extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Notification", "ChangeUserState", "NoActionConfig"];
    }
}

export function ActionConfig_$reflection() {
    return union_type("Shared.RuleModels.ActionConfig", [], ActionConfig, () => [[["Item", NotificationConfig_$reflection()]], [["Item", ChangeUserStateConfig_$reflection()]], []]);
}

/**
 * Discriminator for the persisted `action_config_kind` column.
 */
export function ActionConfig__KindToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

/**
 * Notification payload to persist into the notification columns. Returns `Some` for the
 * `Notification` case and for `ChangeUserState` with an attached follow-up; otherwise `None`.
 */
export function ActionConfig__NotificationFields(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0].Notification;
        case 2:
            return undefined;
        default:
            return this$.fields[0];
    }
}

/**
 * Value for the `action_user_state` column; only set for the `ChangeUserState` case.
 */
export function ActionConfig__UserStateValue(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].NewState;
    }
    else {
        return undefined;
    }
}

/**
 * Reconstruct from typed columns. Throws on invalid combinations.
 */
export function ActionConfig_FromColumns_Z4E8052B3(kind, title, message, recipients, sendEmail, url, userState) {
    const buildNotification = () => {
        let m;
        let matchResult, m_1, t_1;
        if (title != null) {
            if (message != null) {
                if ((m = message, !isNullOrWhiteSpace(title) && !isNullOrWhiteSpace(m))) {
                    matchResult = 0;
                    m_1 = message;
                    t_1 = title;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new NotificationConfig(t_1, m_1, defaultArg(map(RecipientType_FromInt_Z524259A4, recipients), new RecipientType(0, [])), defaultArg(sendEmail, false), url);
            default:
                return undefined;
        }
    };
    switch (kind) {
        case 0: {
            const matchValue_1 = buildNotification();
            if (matchValue_1 == null) {
                throw new Error("Invalid Notification action: title and message columns are required when action_config_kind = 0.");
            }
            else {
                return new ActionConfig(0, [matchValue_1]);
            }
        }
        case 1:
            if (userState == null) {
                throw new Error("Invalid ChangeUserState action: action_user_state column is required when action_config_kind = 1.");
            }
            else {
                return new ActionConfig(1, [new ChangeUserStateConfig(userState, buildNotification())]);
            }
        case 2:
            return new ActionConfig(2, []);
        default:
            throw new Error(`Invalid action_config_kind: ${kind}`);
    }
}

export class GlobalRule extends Record {
    constructor(Id, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig, Inserted, Updated) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
        this.Inserted = Inserted;
        this.Updated = Updated;
    }
}

export function GlobalRule_$reflection() {
    return record_type("Shared.RuleModels.GlobalRule", [], GlobalRule, () => [["Id", int32_type], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()], ["Inserted", class_type("System.DateTime")], ["Updated", option_type(class_type("System.DateTime"))]]);
}

export class TrackRule extends Record {
    constructor(Id, TrackId, TrackName, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig, Inserted, Updated) {
        super();
        this.Id = (Id | 0);
        this.TrackId = (TrackId | 0);
        this.TrackName = TrackName;
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
        this.Inserted = Inserted;
        this.Updated = Updated;
    }
}

export function TrackRule_$reflection() {
    return record_type("Shared.RuleModels.TrackRule", [], TrackRule, () => [["Id", int32_type], ["TrackId", int32_type], ["TrackName", option_type(string_type)], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()], ["Inserted", class_type("System.DateTime")], ["Updated", option_type(class_type("System.DateTime"))]]);
}

export class TrackLevelRule extends Record {
    constructor(Id, TrackLevelId, TrackLevelName, TrackId, TrackName, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig, Inserted, Updated, CourseFilterIds, RequireAllCourses) {
        super();
        this.Id = (Id | 0);
        this.TrackLevelId = (TrackLevelId | 0);
        this.TrackLevelName = TrackLevelName;
        this.TrackId = TrackId;
        this.TrackName = TrackName;
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
        this.Inserted = Inserted;
        this.Updated = Updated;
        this.CourseFilterIds = CourseFilterIds;
        this.RequireAllCourses = RequireAllCourses;
    }
}

export function TrackLevelRule_$reflection() {
    return record_type("Shared.RuleModels.TrackLevelRule", [], TrackLevelRule, () => [["Id", int32_type], ["TrackLevelId", int32_type], ["TrackLevelName", option_type(string_type)], ["TrackId", option_type(int32_type)], ["TrackName", option_type(string_type)], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()], ["Inserted", class_type("System.DateTime")], ["Updated", option_type(class_type("System.DateTime"))], ["CourseFilterIds", array_type(int32_type)], ["RequireAllCourses", bool_type]]);
}

export class NewGlobalRule extends Record {
    constructor(Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
    }
}

export function NewGlobalRule_$reflection() {
    return record_type("Shared.RuleModels.NewGlobalRule", [], NewGlobalRule, () => [["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()]]);
}

export class NewTrackRule extends Record {
    constructor(TrackId, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig) {
        super();
        this.TrackId = (TrackId | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
    }
}

export function NewTrackRule_$reflection() {
    return record_type("Shared.RuleModels.NewTrackRule", [], NewTrackRule, () => [["TrackId", int32_type], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()]]);
}

export class NewTrackLevelRule extends Record {
    constructor(TrackLevelId, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig, CourseFilterIds, RequireAllCourses) {
        super();
        this.TrackLevelId = (TrackLevelId | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
        this.CourseFilterIds = CourseFilterIds;
        this.RequireAllCourses = RequireAllCourses;
    }
}

export function NewTrackLevelRule_$reflection() {
    return record_type("Shared.RuleModels.NewTrackLevelRule", [], NewTrackLevelRule, () => [["TrackLevelId", int32_type], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()], ["CourseFilterIds", array_type(int32_type)], ["RequireAllCourses", bool_type]]);
}

export class UpdateGlobalRule extends Record {
    constructor(Id, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
    }
}

export function UpdateGlobalRule_$reflection() {
    return record_type("Shared.RuleModels.UpdateGlobalRule", [], UpdateGlobalRule, () => [["Id", int32_type], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()]]);
}

export class UpdateTrackRule extends Record {
    constructor(Id, TrackId, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig) {
        super();
        this.Id = (Id | 0);
        this.TrackId = (TrackId | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
    }
}

export function UpdateTrackRule_$reflection() {
    return record_type("Shared.RuleModels.UpdateTrackRule", [], UpdateTrackRule, () => [["Id", int32_type], ["TrackId", int32_type], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()]]);
}

export class UpdateTrackLevelRule extends Record {
    constructor(Id, TrackLevelId, Name, Description, Enabled, Priority, ShowAutomationCountdown, TriggerType, TriggerConfig, ActionType, ActionConfig, CourseFilterIds, RequireAllCourses) {
        super();
        this.Id = (Id | 0);
        this.TrackLevelId = (TrackLevelId | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.Priority = (Priority | 0);
        this.ShowAutomationCountdown = ShowAutomationCountdown;
        this.TriggerType = TriggerType;
        this.TriggerConfig = TriggerConfig;
        this.ActionType = ActionType;
        this.ActionConfig = ActionConfig;
        this.CourseFilterIds = CourseFilterIds;
        this.RequireAllCourses = RequireAllCourses;
    }
}

export function UpdateTrackLevelRule_$reflection() {
    return record_type("Shared.RuleModels.UpdateTrackLevelRule", [], UpdateTrackLevelRule, () => [["Id", int32_type], ["TrackLevelId", int32_type], ["Name", string_type], ["Description", option_type(string_type)], ["Enabled", bool_type], ["Priority", int32_type], ["ShowAutomationCountdown", bool_type], ["TriggerType", TriggerType_$reflection()], ["TriggerConfig", TriggerConfig_$reflection()], ["ActionType", ActionType_$reflection()], ["ActionConfig", ActionConfig_$reflection()], ["CourseFilterIds", array_type(int32_type)], ["RequireAllCourses", bool_type]]);
}

export class EmailTemplate extends Record {
    constructor(Id, TemplateKey, Subject, BodyHtml, Description, IsActive, AvailablePlaceholders, Inserted, Updated) {
        super();
        this.Id = (Id | 0);
        this.TemplateKey = TemplateKey;
        this.Subject = Subject;
        this.BodyHtml = BodyHtml;
        this.Description = Description;
        this.IsActive = IsActive;
        this.AvailablePlaceholders = AvailablePlaceholders;
        this.Inserted = Inserted;
        this.Updated = Updated;
    }
}

export function EmailTemplate_$reflection() {
    return record_type("Shared.RuleModels.EmailTemplate", [], EmailTemplate, () => [["Id", int32_type], ["TemplateKey", string_type], ["Subject", string_type], ["BodyHtml", string_type], ["Description", option_type(string_type)], ["IsActive", bool_type], ["AvailablePlaceholders", array_type(string_type)], ["Inserted", class_type("System.DateTime")], ["Updated", option_type(class_type("System.DateTime"))]]);
}

export class NewEmailTemplate extends Record {
    constructor(TemplateKey, Subject, BodyHtml, Description, AvailablePlaceholders) {
        super();
        this.TemplateKey = TemplateKey;
        this.Subject = Subject;
        this.BodyHtml = BodyHtml;
        this.Description = Description;
        this.AvailablePlaceholders = AvailablePlaceholders;
    }
}

export function NewEmailTemplate_$reflection() {
    return record_type("Shared.RuleModels.NewEmailTemplate", [], NewEmailTemplate, () => [["TemplateKey", string_type], ["Subject", string_type], ["BodyHtml", string_type], ["Description", option_type(string_type)], ["AvailablePlaceholders", array_type(string_type)]]);
}

export class UpdateEmailTemplate extends Record {
    constructor(Id, TemplateKey, Subject, BodyHtml, Description, AvailablePlaceholders) {
        super();
        this.Id = (Id | 0);
        this.TemplateKey = TemplateKey;
        this.Subject = Subject;
        this.BodyHtml = BodyHtml;
        this.Description = Description;
        this.AvailablePlaceholders = AvailablePlaceholders;
    }
}

export function UpdateEmailTemplate_$reflection() {
    return record_type("Shared.RuleModels.UpdateEmailTemplate", [], UpdateEmailTemplate, () => [["Id", int32_type], ["TemplateKey", string_type], ["Subject", string_type], ["BodyHtml", string_type], ["Description", option_type(string_type)], ["AvailablePlaceholders", array_type(string_type)]]);
}

export class RuleExecutionLog extends Record {
    constructor(Id, RuleScope, RuleId, RuleName, ExecutedAt, UserId, UserName, TrackId, TrackName, TrackLevelId, TrackLevelName, Status, ErrorMessage, ActionDetails, CycleStartDate) {
        super();
        this.Id = (Id | 0);
        this.RuleScope = RuleScope;
        this.RuleId = (RuleId | 0);
        this.RuleName = RuleName;
        this.ExecutedAt = ExecutedAt;
        this.UserId = UserId;
        this.UserName = UserName;
        this.TrackId = TrackId;
        this.TrackName = TrackName;
        this.TrackLevelId = TrackLevelId;
        this.TrackLevelName = TrackLevelName;
        this.Status = Status;
        this.ErrorMessage = ErrorMessage;
        this.ActionDetails = ActionDetails;
        this.CycleStartDate = CycleStartDate;
    }
}

export function RuleExecutionLog_$reflection() {
    return record_type("Shared.RuleModels.RuleExecutionLog", [], RuleExecutionLog, () => [["Id", int32_type], ["RuleScope", RuleScope_$reflection()], ["RuleId", int32_type], ["RuleName", string_type], ["ExecutedAt", class_type("System.DateTime")], ["UserId", option_type(int32_type)], ["UserName", option_type(string_type)], ["TrackId", option_type(int32_type)], ["TrackName", option_type(string_type)], ["TrackLevelId", option_type(int32_type)], ["TrackLevelName", option_type(string_type)], ["Status", RuleExecutionStatus_$reflection()], ["ErrorMessage", option_type(string_type)], ["ActionDetails", option_type(string_type)], ["CycleStartDate", option_type(class_type("System.DateTime"))]]);
}

export class UserAutomationCountdown extends Record {
    constructor(RuleName, TrackName, TrackLevelName, TriggerType, ActionType, ReferenceDate, FireDate) {
        super();
        this.RuleName = RuleName;
        this.TrackName = TrackName;
        this.TrackLevelName = TrackLevelName;
        this.TriggerType = TriggerType;
        this.ActionType = ActionType;
        this.ReferenceDate = ReferenceDate;
        this.FireDate = FireDate;
    }
}

export function UserAutomationCountdown_$reflection() {
    return record_type("Shared.RuleModels.UserAutomationCountdown", [], UserAutomationCountdown, () => [["RuleName", string_type], ["TrackName", option_type(string_type)], ["TrackLevelName", option_type(string_type)], ["TriggerType", TriggerType_$reflection()], ["ActionType", ActionType_$reflection()], ["ReferenceDate", class_type("System.DateTime")], ["FireDate", class_type("System.DateTime")]]);
}

export class DaysInactivityConfig extends Record {
    constructor(DaysThreshold) {
        super();
        this.DaysThreshold = (DaysThreshold | 0);
    }
}

export function DaysInactivityConfig_$reflection() {
    return record_type("Shared.RuleModels.DaysInactivityConfig", [], DaysInactivityConfig, () => [["DaysThreshold", int32_type]]);
}

export class DaysAfterEnrollmentConfig extends Record {
    constructor(DaysAfter) {
        super();
        this.DaysAfter = (DaysAfter | 0);
    }
}

export function DaysAfterEnrollmentConfig_$reflection() {
    return record_type("Shared.RuleModels.DaysAfterEnrollmentConfig", [], DaysAfterEnrollmentConfig, () => [["DaysAfter", int32_type]]);
}

export class DaysOnLevelConfig extends Record {
    constructor(DaysThreshold) {
        super();
        this.DaysThreshold = (DaysThreshold | 0);
    }
}

export function DaysOnLevelConfig_$reflection() {
    return record_type("Shared.RuleModels.DaysOnLevelConfig", [], DaysOnLevelConfig, () => [["DaysThreshold", int32_type]]);
}

export class DaysAfterVerificationConfig extends Record {
    constructor(DaysAfter) {
        super();
        this.DaysAfter = (DaysAfter | 0);
    }
}

export function DaysAfterVerificationConfig_$reflection() {
    return record_type("Shared.RuleModels.DaysAfterVerificationConfig", [], DaysAfterVerificationConfig, () => [["DaysAfter", int32_type]]);
}

export class WindowDaysConfig extends Record {
    constructor(WindowDays) {
        super();
        this.WindowDays = (WindowDays | 0);
    }
}

export function WindowDaysConfig_$reflection() {
    return record_type("Shared.RuleModels.WindowDaysConfig", [], WindowDaysConfig, () => [["WindowDays", int32_type]]);
}

export class GetRuleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RuleNotFound", "Unauthorized"];
    }
}

export function GetRuleError_$reflection() {
    return union_type("Shared.RuleModels.GetRuleError", [], GetRuleError, () => [[], []]);
}

export class AddRuleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ValidationFailed", "Conflict", "TrackNotFound", "TrackLevelNotFound", "Unauthorized"];
    }
}

export function AddRuleError_$reflection() {
    return union_type("Shared.RuleModels.AddRuleError", [], AddRuleError, () => [[["Item", string_type]], [["Item", string_type]], [], [], []]);
}

export class UpdateRuleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RuleNotFound", "ValidationFailed", "Unauthorized"];
    }
}

export function UpdateRuleError_$reflection() {
    return union_type("Shared.RuleModels.UpdateRuleError", [], UpdateRuleError, () => [[], [["Item", string_type]], []]);
}

export class DeleteRuleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RuleNotFound", "HasExecutions", "Unauthorized"];
    }
}

export function DeleteRuleError_$reflection() {
    return union_type("Shared.RuleModels.DeleteRuleError", [], DeleteRuleError, () => [[], [], []]);
}

export class TestRuleError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RuleNotFound", "ValidationFailed", "Unauthorized"];
    }
}

export function TestRuleError_$reflection() {
    return union_type("Shared.RuleModels.TestRuleError", [], TestRuleError, () => [[], [["Item", string_type]], []]);
}

export class GetEmailTemplateError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TemplateNotFound", "Unauthorized"];
    }
}

export function GetEmailTemplateError_$reflection() {
    return union_type("Shared.RuleModels.GetEmailTemplateError", [], GetEmailTemplateError, () => [[], []]);
}

export class AddEmailTemplateError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ValidationFailed", "TemplateKeyConflict", "Unauthorized"];
    }
}

export function AddEmailTemplateError_$reflection() {
    return union_type("Shared.RuleModels.AddEmailTemplateError", [], AddEmailTemplateError, () => [[["Item", string_type]], [], []]);
}

export class UpdateEmailTemplateError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TemplateNotFound", "ValidationFailed", "Unauthorized"];
    }
}

export function UpdateEmailTemplateError_$reflection() {
    return union_type("Shared.RuleModels.UpdateEmailTemplateError", [], UpdateEmailTemplateError, () => [[], [["Item", string_type]], []]);
}

//# sourceMappingURL=RuleModels.jsx.map
